import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function Tabs({ tabs = [], selected, onChange }) {
  return (
    <Box display="flex" alignItems="center">
      {tabs.map((tab, index) => (
        <React.Fragment key={tab.value}>
          <Box display="flex" flexDirection="column" alignItems="center" mr={index !== tabs.length - 1 ? 4 : 0}>
            <Button
              onClick={() => onChange(tab.value)}
              sx={{
                color: "var(--brand-950)",
                textTransform: "none",
                fontWeight: 800,
              }}
              startIcon={tab.icon && <tab.icon />}
            >
              {tab.label}
            </Button>
            <Box
              sx={{
                height: "2px",
                bgcolor:
                  selected === tab.value
                    ? "var(--brand-500)"
                    : "var(--gray-300)",
                width: "120%",
                mt: "3px",
                ml: "20%",
                borderRadius: "2px",
              }}
            />
          </Box>

          {index !== tabs.length - 1 && (
            <Typography
              variant="body2"
              color="var(--brand-950)"
              fontWeight="bold"
              mx={3}
            >
              (OR)
            </Typography>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}
